/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { Store } from 'redux';
import { IPropertiesValidator } from './ValidatorTypes';

class VisualizationTypeValidator implements IPropertiesValidator {
    currentStore: Store;

    constructor(store: Store) {
        this.currentStore = store;
    }

    validate(properties: any) {
        const state = this.currentStore.getState();
        const canvasVal = properties ? properties.canvas : state.canvas;
        if (canvasVal && canvasVal.type) {
            const enabled = state.visualizationTypesRegistry.filter((visualizationType: any) => visualizationType.available === true)
                .map((type: any) => type.descriptor.name);
            if (enabled && enabled.indexOf(canvasVal.type) === -1) {
                return {
                    message: 'The specified visualization type is invalid.',
                    errorCode: 'visualization.type.invalid',
                    parameters: [canvasVal.type]
                }
            }
        }
        return null;
    }
}

export default VisualizationTypeValidator;
